<template>
  <ReactSiteFrame :src="src" />
</template>

<script>
import ReactSiteFrame from '../components/react/iframe'

export default {
  name: 'ChatReact',
  components: {
    ReactSiteFrame
  },
  data() {
    return {
      src: '/view/chat'
    }
  }
}
</script>
